import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap, concatMap, map } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';

@Injectable({
     providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {

     constructor(private authorize: AuthorizeService, private router: Router, private route: ActivatedRoute) { }

     canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
          return this.authorize.getUser().pipe(
               map((user) => {
                    if (user && this.authorize.isSuperAdmin(user['role'])) {
                         return true;
                    }
                    else {
                         this.router.navigate(['error/unauthorized']);
                         return false;
                    }
               })
          );
     }
}
